var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropScv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5055 34.926H29.7474H27.6584H27.2072V24.5198H30.6105C31.4736 24.5198 31.9837 23.539 31.4736 22.8329L24.8533 13.6723C24.4315 13.0838 23.5586 13.0838 23.1369 13.6723L16.5166 22.8329C16.0065 23.539 16.5067 24.5198 17.3796 24.5198H20.783V34.926H20.3318H18.2427H9.24888C4.09971 34.6416 0 29.8259 0 24.6081C0 21.0086 1.95178 17.87 4.84512 16.1733C4.5803 15.4573 4.44299 14.6923 4.44299 13.888C4.44299 10.2101 7.41479 7.23825 11.0928 7.23825C11.8872 7.23825 12.6522 7.37556 13.3682 7.64038C15.4965 3.12873 20.0866 0 25.4221 0C32.3269 0.00980793 38.0155 5.29628 38.6629 12.0343C43.9689 12.9465 48 17.8602 48 23.4213C48 29.3649 43.3707 34.5141 37.5055 34.926Z",
    fill: "#3D8B82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropScv);
export default __webpack_public_path__ + "static/media/drop-scv.2e4a6b8e.svg";
export { ForwardRef as ReactComponent };